import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { VehicleNote } from '../../../shared/domain/note';
import { VehicleNoteService } from '../../../shared/services/vehicle-note.service';
import { fadeIn } from '@nw/ui-core-shared/animations/animations';
import { Store } from '@ngrx/store';
import { WatchlistApplicationState } from '../../../store/watchlist-state';
import { WatchListActions } from '../../../store/actions/WatchListActions';
import { TranslateService } from '@ngx-translate/core';
import { AppUiActions } from '@nw/ui-core-shared/store/actions';
import { MainStoreService } from '@nw/ui-core-shared/store/main-store.service';

@Component({
    selector   : 'nw-vehicle-note-v1',
    templateUrl: './vehicle-note-v1.component.html',
    animations : [fadeIn]
})
export class VehicleNoteComponentV1 implements OnInit {

    private vehicleNoteObj: VehicleNote = {
        'nwVehicleId': '',
        'note'       : ''
    };

    @Input() vehicleId = '';
    @Input() vehicleNote = '';

    private note = '';
    private maxNoteLength = 140;
    public  shortNote;
    screenSize;

    private isUploading = false;

    // @HostBinding('class') hostClass = 'col-md-12';
    @HostBinding('class.edit') isEditView: boolean;

    constructor(private store: Store<WatchlistApplicationState>,
                private vehicleNoteService: VehicleNoteService,
                private watchListActions: WatchListActions,
                private appUiActions: AppUiActions,
                private mainStoreService: MainStoreService,
                private translateService: TranslateService) {
        this.isEditView = false;
        mainStoreService.getStore().select(state => state).subscribe(appMainState => {
            this.screenSize = appMainState.appUiState.screenSize;
        });
    }

    ngOnInit() {
        if (this.vehicleNote) {
            this.note = this.vehicleNote;
        }
    }

    toggleView() {
        this.isEditView = !this.isEditView;
    }

    onCancel() {
        this.note = this.vehicleNote;
        this.toggleView();
    }

    onDelete() {
        this.note = '';
    }

    getTagA8n() {
        if (this.vehicleNote && !this.note) {
            return 'note-delete';
        } else if (!this.vehicleNote && this.note) {
            return 'note-add';
        } else if (this.vehicleNote && this.note) {
            return 'note-update';
        }
    }


    onUpdate() {
        this.isUploading = true;
        this.vehicleNoteObj.note = this.note ? this.note.trim() : '';
        this.vehicleNoteObj.nwVehicleId = this.vehicleId;

        this.vehicleNoteService.updateNote(this.vehicleNoteObj).subscribe(
            (res) => {
                if(res) {
                    this.note = res.note;
                    this.store.dispatch(this.watchListActions.updateVehicleNoteSuccess(res));
                }
            },
            (error) => {
                // display error message
                const golbalError = {
                    'message': this.translateService
                        .instant('pageWatchList.noteUpdateErrMsg')
                };
                this.mainStoreService.getStore().dispatch(this.appUiActions.showGlobalError(golbalError));

                // reset note on error
                this.note = this.vehicleNote;
                this.isUploading = false;
            },
            () => {
                this.vehicleNote = this.note ? this.note.trim() : '';
                this.toggleView();
                this.isUploading = false;
            });
    }

    characterCounter(note): number {
        if (note) {
            return this.maxNoteLength - note.trim().length;
        }
        return this.maxNoteLength;
    }

    createShortNote(initialNote) : string {
        let trancateLength = 30;
        if (initialNote && initialNote.length > trancateLength) {
            this.shortNote = initialNote.substring(0, trancateLength) + ' ...';
        } else {
            this.shortNote = initialNote;
        }
        return this.shortNote;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/components/components-v1/vehicle-note-v1/vehicle-note-v1.component.ts